import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': 'http://818tp.cn/#organization',
        name: '吃瓜51网',
        url: 'http://818tp.cn/',
        description: '吃瓜51网是全网领先的娱乐资讯与热点事件追踪平台',
        foundingDate: '2023',
        contactPoint: [
          { '@type': 'ContactPoint', email: 'hello@818tp.cn', contactType: '爆料投稿' },
          { '@type': 'ContactPoint', email: 'hello@818tp.cn', contactType: '商务合作' },
        ],
      },
      {
        '@type': 'WebPage',
        '@id': 'http://818tp.cn/about#webpage',
        url: 'http://818tp.cn/about',
        name: '关于我们 - 吃瓜51网',
        isPartOf: { '@id': 'http://818tp.cn/#website' },
        about: { '@id': 'http://818tp.cn/#organization' },
        breadcrumb: { '@id': 'http://818tp.cn/about#breadcrumb' },
      },
      {
        '@type': 'BreadcrumbList',
        '@id': 'http://818tp.cn/about#breadcrumb',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://818tp.cn/' },
          { '@type': 'ListItem', position: 2, name: '关于我们' },
        ],
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutJsonLd) }}
      />
      <Navbar />
      <main>
        <section className="relative w-full min-h-[420px] md:min-h-[500px] flex items-center overflow-hidden" aria-labelledby="about-hero-title">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20representing%20modern%20digital%20journalism%20and%20media%20platform%2C%20warm%20dark%20tones%20with%20lime%20green%20neon%20accents%2C%20mysterious%20yet%20trustworthy%20atmosphere%2C%20elegant%20editorial%20photography%20style%2C%20Chinese%20internet%20media%20aesthetic%2C%20glowing%20data%20visualizations%2C%20cinematic%20wide%20shot%2C%20no%20text%20or%20faces&width=1800&height=900&seq=about-hero-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
              aria-hidden="true"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
          </div>

          <div className="relative z-10 w-full px-4 md:px-8 pt-24 pb-16 md:pt-28 md:pb-20">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row lg:items-end gap-6 lg:gap-16">
                <div className="lg:w-1/2">
                  <nav className="flex items-center gap-2 text-xs font-label text-background-50/60 mb-4" aria-label="面包屑导航">
                    <Link to="/" className="hover:text-background-50 transition-colors cursor-pointer">首页</Link>
                    <i className="ri-arrow-right-s-line"></i>
                    <span className="text-accent-400">关于我们</span>
                  </nav>
                  <h1 id="about-hero-title" className="font-heading font-black text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight tracking-tight">
                    关于吃瓜<span className="text-accent-400">51</span>
                  </h1>
                </div>
                <div className="lg:w-1/2">
                  <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-4">
                    吃瓜51网是全网领先的娱乐资讯与热点事件追踪平台，致力于为用户提供最新最全的吃瓜内容。
                  </p>
                  <a href="#brand-story" className="inline-flex items-center gap-2 text-sm font-label font-bold text-accent-400 hover:text-accent-300 transition-colors group cursor-pointer">
                    了解更多
                    <i className="ri-arrow-down-line group-hover:translate-y-1 transition-transform"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent z-[5]"></div>
        </section>

        <section id="brand-story" className="py-14 md:py-20 bg-secondary-50/60" aria-labelledby="story-title">
          <div className="max-w-3xl mx-auto px-4 md:px-8">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
              <div className="lg:w-auto flex-shrink-0">
                <p className="text-xs font-label font-medium text-foreground-400 mb-2">
                  / 品牌故事
                </p>
              </div>
              <div className="lg:flex-1">
                <h2 id="story-title" className="font-heading font-black text-xl md:text-2xl text-foreground-950 mb-6">
                  用心做最专业的吃瓜平台
                </h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  吃瓜51网创立于2023年，由一群热爱娱乐资讯、深耕互联网内容领域的资深媒体人联合创办。我们致力于打破信息壁垒，为每一位吃瓜群众提供真实、独家的爆料内容。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  在信息爆炸的时代，真假消息混杂。吃瓜51坚持"爆料有据、追踪到底"的原则，每一条内容都经过多方核实与交叉验证，确保用户接收到的每一条瓜料都经得起推敲。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
                  目前，吃瓜51已拥有超过500万忠实用户，日均访问量突破200万人次。我们的报道被多家主流媒体引用，成为行业内最具影响力的吃瓜资讯平台之一。
                </p>
                <div className="flex items-center gap-4">
                  <div className="flex -space-x-3">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20circular%20avatar%20portrait%20of%20Chinese%20male%20media%20founder%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20background%2C%20confident%20mature%20expression%2C%20editorial%20portrait%20photography%2C%20high%20quality%20headshot%20style&width=80&height=80&seq=about-team-01&orientation=squarish"
                      alt="创始人"
                      className="w-12 h-12 rounded-full border-2 border-secondary-100 object-cover"
                      loading="lazy"
                    />
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20circular%20avatar%20portrait%20of%20Chinese%20female%20chief%20editor%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20background%2C%20intelligent%20professional%20expression%2C%20editorial%20portrait%20photography%2C%20high%20quality%20headshot&width=80&height=80&seq=about-team-02&orientation=squarish"
                      alt="主编"
                      className="w-12 h-12 rounded-full border-2 border-secondary-100 object-cover"
                      loading="lazy"
                    />
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20circular%20avatar%20portrait%20of%20Chinese%20male%20senior%20reporter%2C%20warm%20studio%20lighting%2C%20clean%20minimal%20background%2C%20sharp%20inquisitive%20expression%2C%20editorial%20portrait%20photography%2C%20high%20quality%20headshot%20style&width=80&height=80&seq=about-team-03&orientation=squarish"
                      alt="资深记者"
                      className="w-12 h-12 rounded-full border-2 border-secondary-100 object-cover"
                      loading="lazy"
                    />
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20circular%20avatar%20portrait%20of%20Chinese%20female%20content%20director%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20background%2C%20creative%20dynamic%20expression%2C%20editorial%20portrait%20photography%2C%20high%20quality%20headshot&width=80&height=80&seq=about-team-04&orientation=squarish"
                      alt="内容总监"
                      className="w-12 h-12 rounded-full border-2 border-secondary-100 object-cover"
                      loading="lazy"
                    />
                  </div>
                  <p className="text-xs text-foreground-500 font-label">
                    核心团队成员 · 多位资深媒体人联合创立
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="reputation" className="py-14 md:py-20 bg-background-50" aria-labelledby="reputation-title">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="mb-10 md:mb-14">
              <p className="text-xs font-label font-medium text-foreground-400 uppercase tracking-widest mb-2">
                平台口碑
              </p>
              <h2 id="reputation-title" className="font-heading font-black text-2xl md:text-4xl text-foreground-950 leading-tight max-w-2xl">
                数百万吃瓜群众的
                <br />
                共同选择与信赖
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              <div className="bg-background-100 rounded-xl p-6 md:p-8">
                <div className="w-12 h-12 flex items-center justify-center mb-5">
                  <i className="ri-speed-line text-3xl text-foreground-950"></i>
                </div>
                <h3 className="font-heading font-bold text-lg text-foreground-950 mb-3">
                  极速响应
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  7×24小时不间断监控全网热点，平均30分钟内完成爆料信息核实与发布。比主流媒体平均快3-5小时，让您永远抢占吃瓜先机。
                </p>
              </div>

              <div className="bg-background-100 rounded-xl p-6 md:p-8">
                <div className="w-12 h-12 flex items-center justify-center mb-5">
                  <i className="ri-shield-user-line text-3xl text-foreground-950"></i>
                </div>
                <h3 className="font-heading font-bold text-lg text-foreground-950 mb-3">
                  匿名保护
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  严格保护爆料人隐私信息，采用业界领先的匿名化处理技术。上线以来从未发生爆料人信息泄露事件，深受线人信赖。
                </p>
              </div>

              <div className="bg-background-100 rounded-xl p-6 md:p-8">
                <div className="w-12 h-12 flex items-center justify-center mb-5">
                  <i className="ri-verified-badge-line text-3xl text-foreground-950"></i>
                </div>
                <h3 className="font-heading font-bold text-lg text-foreground-950 mb-3">
                  内容真实
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  独创"三方核实"机制，每条爆料均经过至少三个独立信源的交叉验证。内容真实率高达98.5%，远高于行业平均水平。
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mt-10 md:mt-14">
              <div className="text-center">
                <p className="font-heading font-black text-3xl md:text-4xl text-accent-500 mb-1">500万+</p>
                <p className="text-sm text-foreground-500 font-label">忠实用户</p>
              </div>
              <div className="text-center">
                <p className="font-heading font-black text-3xl md:text-4xl text-accent-500 mb-1">200万+</p>
                <p className="text-sm text-foreground-500 font-label">日均访问</p>
              </div>
              <div className="text-center">
                <p className="font-heading font-black text-3xl md:text-4xl text-accent-500 mb-1">3000+</p>
                <p className="text-sm text-foreground-500 font-label">独家爆料</p>
              </div>
              <div className="text-center">
                <p className="font-heading font-black text-3xl md:text-4xl text-accent-500 mb-1">98.5%</p>
                <p className="text-sm text-foreground-500 font-label">真实率</p>
              </div>
            </div>
          </div>
        </section>

        <section id="contact" className="py-14 md:py-20 bg-secondary-50/60" aria-labelledby="contact-title">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="max-w-2xl mx-auto text-center mb-10 md:mb-14">
              <p className="text-xs font-label font-medium text-foreground-400 uppercase tracking-widest mb-2">
                联系我们
              </p>
              <h2 id="contact-title" className="font-heading font-black text-2xl md:text-4xl text-foreground-950 leading-tight">
                有爆料？欢迎联系我们
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed mt-4">
                如果您有独家内幕消息或爆料线索，欢迎通过以下方式与我们取得联系。我们承诺严格保护爆料人的隐私安全。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-4xl mx-auto">
              <div className="bg-background-50 rounded-xl p-6 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center bg-accent-100 rounded-full mb-4">
                  <i className="ri-mail-line text-2xl text-accent-700"></i>
                </div>
                <h3 className="font-heading font-bold text-base text-foreground-950 mb-2">爆料邮箱</h3>
                <p className="text-sm text-foreground-600 mb-1">hello@818tp.cn</p>
                <p className="text-xs text-foreground-400">24小时内回复</p>
              </div>

              <div className="bg-background-50 rounded-xl p-6 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center bg-accent-100 rounded-full mb-4">
                  <i className="ri-wechat-line text-2xl text-accent-700"></i>
                </div>
                <h3 className="font-heading font-bold text-base text-foreground-950 mb-2">微信客服</h3>
                <p className="text-sm text-foreground-600 mb-1">chigua51kefu</p>
                <p className="text-xs text-foreground-400">工作日 9:00-18:00</p>
              </div>

              <div className="bg-background-50 rounded-xl p-6 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center bg-accent-100 rounded-full mb-4">
                  <i className="ri-phone-line text-2xl text-accent-700"></i>
                </div>
                <h3 className="font-heading font-bold text-base text-foreground-950 mb-2">商务合作</h3>
                <p className="text-sm text-foreground-600 mb-1">hello@818tp.cn</p>
                <p className="text-xs text-foreground-400">广告/品牌合作</p>
              </div>
            </div>

            <div className="mt-12 max-w-lg mx-auto">
              <h3 className="font-heading font-bold text-lg text-foreground-950 mb-6 text-center">常见问题</h3>
              <div className="space-y-4" itemScope itemType="https://schema.org/FAQPage">
                <div className="bg-background-50 rounded-xl p-5" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h4 className="font-label font-bold text-sm text-foreground-950 mb-2" itemProp="name">
                    如何向吃瓜51提交爆料？
                  </h4>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-sm text-foreground-600 leading-relaxed" itemProp="text">
                      您可以通过发送邮件至 hello@818tp.cn 或添加微信客服 chigua51kefu 提交爆料线索。我们会在24小时内进行初步核实并回复。所有爆料人均享有匿名保护。
                    </p>
                  </div>
                </div>

                <div className="bg-background-50 rounded-xl p-5" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h4 className="font-label font-bold text-sm text-foreground-950 mb-2" itemProp="name">
                    吃瓜51的内容可信度如何？
                  </h4>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-sm text-foreground-600 leading-relaxed" itemProp="text">
                      吃瓜51独创"三方核实"机制，每条爆料都会经过至少三个独立信源的交叉验证后才正式发布。我们的内容真实率高达98.5%。如发现内容有误，欢迎随时联系我们更正。
                    </p>
                  </div>
                </div>

                <div className="bg-background-50 rounded-xl p-5" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h4 className="font-label font-bold text-sm text-foreground-950 mb-2" itemProp="name">
                    吃瓜51有手机App吗？
                  </h4>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-sm text-foreground-600 leading-relaxed" itemProp="text">
                      目前吃瓜51以网页版为主要平台，适配手机、平板和电脑等多终端访问。App正在紧锣密鼓地开发中，预计今年下半年上线，敬请期待！
                    </p>
                  </div>
                </div>

                <div className="bg-background-50 rounded-xl p-5" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                  <h4 className="font-label font-bold text-sm text-foreground-950 mb-2" itemProp="name">
                    如何与吃瓜51进行商务合作？
                  </h4>
                  <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                    <p className="text-sm text-foreground-600 leading-relaxed" itemProp="text">
                      品牌方或广告主可发送合作意向至 hello@818tp.cn，我们的商务团队会在3个工作日内与您联系。我们提供品牌曝光、内容定制、KOL联动等多种合作形式。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}